export const CONFIRMED_GET_CONTENT = "CONFIRMED_GET_CONTENT";
export const CONFIRMED_CREATE_CONTENT = "CONFIRMED_CREATE_CONTENT";
export const CONFIRMED_EDIT_CONTENT = "CONFIRMED_EDIT_CONTENT";
export const CONFIRMED_DELETE_CONTENT = "CONFIRMED_DELETE_CONTENT";
export const CONFIRMED_SEND_CONTENT = "CONFIRMED_SEND_CONTENT"
export const FAILED_SEND_CONTENT = "FAILED_SEND_CONTENT"
